import { render } from "./FacebookIntegrationSettings.vue?vue&type=template&id=6f6d0385"
import script from "./FacebookIntegrationSettings.vue?vue&type=script&lang=js"
export * from "./FacebookIntegrationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__